import { Commands } from '../../../../vendor_core/core/src/commands/CommandEnum';
import CommandManager from '../../../../vendor_core/core/src/commands/CommandManager';
import { SetBetCommand } from '../../../../vendor_core/core/src/commands/GameCommands';
import PointerEvents from '../../../../vendor_core/core/src/const/PointerEvents';
import SoundVars from '../../../../vendor_core/core/src/const/SoundVars';
import BetModel from '../../../../vendor_core/core/src/model/BetModel';
import BuyFeatureModel from '../../../../vendor_core/core/src/model/BuyFeatureModel';
import BuyFeaturePopup from '../../../../vendor_core/core/src/ui/popups/BuyFeaturePopup';
import { UIComponents } from '../../../../vendor_core/core/src/ui/UIComponents';
import KeyboardManager, { Key } from '../../../../vendor_core/core/src/utils/KeyboardManager';
import { DefaultLayers } from '../../../../vendor_core/core/src/utils/Layers';
import SoundController from '../../../../vendor_core/core/src/utils/SoundController';
import ViewManager from '../../../../vendor_core/core/src/utils/ViewManager';
import TextField from '../../../../vendor_core/core/src/views/components/TextField';
import { MoneyField } from '../../../../vendor_core/core/src/views/MoneyField';

export default class BBBuyFeaturePopup extends BuyFeaturePopup {
    public show = (callback?: Function) => {
        KeyboardManager.disable();
        this.hidden = false;
        this.scene = this.layer.setScene('futurebuy');
        // prevent execute behind buttons events !
        this.scene.interactive = true;
        const cloudAnim = ViewManager.getLayer("CloudAnim").setScene("open").spineAnimations.get("popup_win");
        cloudAnim.playChainingStates("feature_bye");
        // anim.play("intro", true);
        // this.animScene = ViewManager.getLayer("BuyFeaturePopup").setScene("open");
        this.closeBtn = this.scene.buttons.get("cancel");
        this.playBtn = this.scene.buttons.get("ok");
        this.betField = this.scene.sceneMoneyFields.get('amount') as MoneyField;
        this.totalPriceField = this.scene.sceneMoneyFields.get('total_amount') as MoneyField;
        this.plusBtn = this.scene.buttons.get("plus");
        this.minusBtn = this.scene.buttons.get("minus");

        let textFields = [this.scene.sceneTextFields.get("text_1") as TextField, this.scene.sceneTextFields.get("text_2") as TextField];

        this.setUpFontSize(textFields);
        this.setBetOptions();
        this.setBet();
        this.setTotalPrice();
        this.setInteractionOnPlus();
        this.setInteractionOnMinus();
        this.setInteractionOnPlay();
        this.setInteractionOnClose(callback);
    }

    protected setInteractionOnClose = (callback?: Function) => {
        const cloudAnim = ViewManager.getLayer("CloudAnim").setScene("open").spineAnimations.get("popup_win");
        this.closeBtn.on(PointerEvents.DOWN, (e) => {
            e.stopPropagation();
            SoundController.playSound(SoundVars.BUTTON_CLICK);
            cloudAnim.playAsync("outro_electric_win").then(() => {
                if (callback) {
                    callback();
                }
                this.hide();
                // cloudAnim.stop(true);
            })
        });
    };
    private setUpFontSize = (textFields: TextField[]) => {
        let longestStringTextField = this.getLongestTextField(textFields);
        let minFontSize = longestStringTextField.style.fontSize;
        (textFields).forEach(tx => {
            tx.style.fontSize = minFontSize;
        })

    }

    public hide() {
        super.hide()
        ViewManager.getLayer("CloudAnim").clear();
    }

    private getLongestTextField = (textFields: TextField[]) => {
        let result: TextField = null;
        textFields.forEach(field => {
            if (result && result.text.length < field.text.length) {
                result = field;
            } else {
                if (result === null) {
                    result = field;
                }
            }
        })

        return result
    }
}
